const philosophies = [
  {
    icon: 'ri-shield-star-line',
    title: '猫咪文化',
    description: '从历史、艺术到文学，我们深入挖掘猫咪在人类文明中的优雅足迹，呈现猫咪文化的深厚底蕴与永恒魅力。',
  },
  {
    icon: 'ri-vip-crown-line',
    title: '绅士美学',
    description: '以绅士的品味审视生活的每一个细节。从家居设计到日常仪式，将猫咪的优雅融入精致生活的方方面面。',
  },
  {
    icon: 'ri-heart-pulse-line',
    title: '科学养猫',
    description: '基于现代兽医学与营养科学，提供专业、严谨、实用的养猫知识。让每一只猫咪都能享受健康优雅的生活。',
  },
];

export default function PhilosophySection() {
  return (
    <section className="py-16 md:py-24 px-4 md:px-6 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <p className="text-xs tracking-widest uppercase text-primary-500 font-medium mb-3 whitespace-nowrap">Our Philosophy</p>
          <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-950 mb-3">
            喵绅士的生活哲学
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto leading-relaxed">
            养猫不只是一种爱好，更是一种生活态度。我们倡导优雅、从容、精致的猫咪生活方式。
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {philosophies.map((item) => (
            <div
              key={item.title}
              className="group text-center p-6 md:p-8 rounded-lg bg-background-50 border border-background-200/60 hover:border-primary-200 transition-all duration-300"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-5 rounded-full bg-primary-50 flex items-center justify-center group-hover:bg-primary-100 transition-colors">
                <i className={`${item.icon} text-xl md:text-2xl text-primary-500 w-6 h-6 flex items-center justify-center`} />
              </div>
              <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground-900 mb-3 whitespace-nowrap">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}